import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  auth, 
  googleProvider, 
  createUserWithEmailAndPassword, 
  signInWithPopup, 
  signInWithPhoneNumber, 
  RecaptchaVerifier, 
  firestore, 
  doc, 
  setDoc 
} from '../../firebase';
import { toast } from 'react-toastify';
import { GoogleLoginButton, PhoneLoginButton } from '../DatabaseAPI/Api';

const NewUserSignIn = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showPhoneInput, setShowPhoneInput] = useState(false);

  const addUserToFirestore = async (user) => {
    await setDoc(doc(firestore, 'UserProfileMaster', user.uid), {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName || displayName,
      phoneNumber: user.phoneNumber,
      createdAt: new Date().toISOString(),
    });
  };

  const handleEmailPasswordSignUp = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      await addUserToFirestore(userCredential.user);
      toast.success("Registration successful!");
      navigate('/inventory_list');
    } catch (error) {
      toast.error("Failed to register. Please try again.");
    }
  };

  const handleGoogleSignUp = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      await addUserToFirestore(result.user);
      toast.success("Google sign-up successful!");
      navigate('/inventory_list');
    } catch (error) {
      toast.error("Failed to sign up with Google. Please try again.");
    }
  };

  const handlePhoneSignUp = async () => {
    if (!phoneNumber) {
      toast.error("Please enter a phone number.");
      return;
    }

    try {
      const recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {}, auth);
      const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier);
      
      // Here you would typically show a confirmation code input
      // For simplicity, we'll just log the user in
      const user = confirmationResult.user;
      await addUserToFirestore(user);
      toast.success("Phone number sign-up successful!");
      navigate('/inventory_list');
    } catch (error) {
      toast.error("Failed to sign up with phone number. Please try again.");
    }
  };

  return (
    <div className="new-user-sign-in">
      <h2>Register New Account</h2>
      <form onSubmit={handleEmailPasswordSignUp}>
        <input 
          type="text" 
          value={displayName} 
          onChange={(e) => setDisplayName(e.target.value)}
          placeholder="Display Name"
          required
        />
        <input 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <input 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
        />
        <button type="submit">Register with Email</button>
      </form>
      <div className="or-divider">or</div>
      <GoogleLoginButton onClick={handleGoogleSignUp} />
      <PhoneLoginButton onClick={() => setShowPhoneInput(true)} />
      {showPhoneInput && (
        <div>
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="Phone Number"
          />
          <button onClick={handlePhoneSignUp}>Sign Up with Phone</button>
          <div id="recaptcha-container"></div>
        </div>
      )}
    </div>
  );
};

export default NewUserSignIn;
